"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.regeneratePUSH = exports.regenerateOTP = exports.resendOTPLogin = void 0;
const resendOTPLogin = (api, progressId, url) => __awaiter(void 0, void 0, void 0, function* () {
    return api.POST(url, undefined, {
        headers: {
            progressId,
        },
    });
});
exports.resendOTPLogin = resendOTPLogin;
const regenerateOTP = (api, progressId, url) => api.POST(url, undefined, {
    headers: {
        progressId,
    },
});
exports.regenerateOTP = regenerateOTP;
const regeneratePUSH = (api, progressId, url) => api.POST(url, undefined, {
    headers: {
        progressId,
    },
});
exports.regeneratePUSH = regeneratePUSH;
//# sourceMappingURL=repository.js.map